import { components } from "react-select";

// Shared chrome icons for the admin list pages (filter bar + table headers).
export const SearchIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M8.965 8.143L12.5 11.676L11.676 12.5L8.143 8.965C7.197 9.72 6.022 10.13 4.812 10.125C1.855 10.125 -0.5 7.77 -0.5 4.812C-0.5 1.855 1.855 -0.5 4.812 -0.5C7.77 -0.5 10.125 1.855 10.125 4.812C10.13 6.022 9.72 7.197 8.965 8.143ZM7.796 7.71C8.545 6.935 8.963 5.899 8.962 4.812C8.962 2.485 7.139 0.662 4.812 0.662C2.485 0.662 0.662 2.485 0.662 4.812C0.662 7.139 2.485 8.962 4.812 8.962C5.899 8.963 6.935 8.545 7.71 7.796L7.796 7.71Z"
      fill="#7C7B7B"
    />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M1 1H9L5 5L1 1Z" fill="#282828" />
  </svg>
);

export const SelectDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ChevronDownIcon />
  </components.DropdownIndicator>
);

export const SortIcon = ({ direction }) => (
  <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M3.5 1L1 3.5H6L3.5 1Z" fill="white" opacity={direction === "asc" ? 1 : 0.4} />
    <path d="M7.5 14L10 11.5H5L7.5 14Z" fill="white" opacity={direction === "desc" ? 1 : 0.4} />
    <path d="M3.5 3.5V11.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity={direction === "asc" ? 1 : 0.4} />
    <path d="M7.5 11.5V3.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity={direction === "desc" ? 1 : 0.4} />
  </svg>
);

// The eye glyph used inside the gold row-action button.
export const TableEyeIcon = () => (
  <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M9 0.75C4.795 0.75 1.547 3.459 0.125 5.999C1.547 8.54 4.795 11.249 9 11.249C13.205 11.249 16.453 8.54 17.875 5.999C16.453 3.459 13.205 0.75 9 0.75ZM9 9.75C6.933 9.75 5.25 8.067 5.25 6C5.25 3.933 6.933 2.25 9 2.25C11.067 2.25 12.75 3.933 12.75 6C12.75 8.067 11.067 9.75 9 9.75ZM9 3.75C7.758 3.75 6.75 4.758 6.75 6C6.75 7.242 7.758 8.25 9 8.25C10.242 8.25 11.25 7.242 11.25 6C11.25 4.758 10.242 3.75 9 3.75Z"
      fill="white"
    />
  </svg>
);

export const TablePencilIcon = () => (
  <svg width="14" height="13" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M0.881836 11.0837L0.881836 14L3.84753 14L12.5943 5.39897L9.62864 2.48271L0.881836 11.0837ZM14.8878 3.14373C15.1962 2.84044 15.1962 2.35051 14.8878 2.04722L13.0372 0.227468C12.7288 -0.0758228 12.2305 -0.0758228 11.9221 0.227468L10.4749 1.6506L13.4405 4.56687L14.8878 3.14373Z"
      fill="white"
    />
  </svg>
);

export const TableTrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M3.5 11.667C3.5 12.4 4.1 13 4.833 13H9.167C9.9 13 10.5 12.4 10.5 11.667V4.667H3.5V11.667ZM11.167 2.667H9.25L8.667 2H5.333L4.75 2.667H2.833V4H11.167V2.667Z"
      fill="currentColor"
    />
  </svg>
);

export const TableCopyIcon = () => (
  <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M15 1.667H7.5C6.583 1.667 5.833 2.417 5.833 3.333v10c0 .917.75 1.667 1.667 1.667H15c.917 0 1.667-.75 1.667-1.667v-10c0-.916-.75-1.666-1.667-1.666Zm0 11.666H7.5v-10H15v10ZM4.167 5v13.333c-.917 0-1.667-.75-1.667-1.666V6.667C2.5 5.75 3.25 5 4.167 5Z"
      fill="currentColor"
    />
  </svg>
);

export const TableCalendarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M5.333 0.667v1.333h5.334V0.667H12v1.333h1.333c0.737 0 1.334 0.597 1.334 1.333v10.667c0 0.736-0.597 1.333-1.334 1.333H2.667c-0.737 0-1.334-0.597-1.334-1.333V3.333C1.333 2.597 1.93 2 2.667 2H4V0.667h1.333ZM13.333 6H2.667v8h10.666V6Zm-8 1.333v1.334H4V7.333h1.333Zm3.334 0v1.334H7.333V7.333h1.334Zm3.333 0v1.334h-1.333V7.333H12ZM5.333 10v1.333H4V10h1.333Zm3.334 0v1.333H7.333V10h1.334Zm3.333 0v1.333h-1.333V10H12Z"
      fill="currentColor"
    />
  </svg>
);
